import { Injectable } from '@angular/core';
import { AppConfig } from '../../config/config.api';
import { StorageService } from './storage.service';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Subject';
import { select, Store } from '@ngrx/store';
import { getToken } from '../store/selectors/auth.selectors';
import { RequestsServices } from './requests.service';
import { from } from 'rxjs';

@Injectable()
export class SearchService extends AppConfig {
  private inputboxSubject = new Subject<any>();
  private mapdataSubject = new Subject<any>();

  accessToken;

  constructor(
    public request: RequestsServices,
    public storage: StorageService,
    private store: Store
  ) {
    super();

    this.store.pipe(select(getToken)).subscribe(accessToken => this.accessToken = accessToken);
  }

  sendSearchKey(msg: string) {
    if (msg === '') {
      return of([]);
    } else {
      return from(this.request.post('establishment_addresses', { keyword: msg }, '', '/list-suggestions'))
        .map((response) => response);
    }
  }

  sendmagicKey(magicKey: string) {
    if (magicKey === '') {
      return of([]);
    } else {
      from(this.request.post('establishment_addresses', { magicKey }, '', '/detail-address'))
        .map((response) => response)
        .subscribe((data) => this.mapdataSubject.next(data));
    }
  }

  getDetail() {
    return this.mapdataSubject.asObservable();
  }

  getClear() {
    return this.inputboxSubject.asObservable();
  }
}
